import { docSigningApiSignatureRequestsListPost } from "../../pages/Documents/documentsApi"

export async function getDocuments(userCtx, onSetDocumentsCounter) {
  const listingBody = {
    groupId: userCtx.session.user.organization_id,
    pageNum: 1,
    pageSize: 100,
    statusFilter: "awaiting_signature",
    recipientIds: [`${userCtx.session.user.staff_id}-STAFF`],
  }

  const result = await docSigningApiSignatureRequestsListPost(
    userCtx.tokenDocumentSign,
    listingBody
  )

  onSetDocumentsCounter(result.numResults)
}

export function documentsButtonAction(user) {
  user.showDocumentRequests("await_my_signature")
}
